import React, { useEffect } from 'react';
import { FileSignature, ExternalLink } from 'lucide-react';

const SignatureBDCPage = () => {
  useEffect(() => {
    // Ouvrir automatiquement dans un nouvel onglet avec le bon lien Oodrive
    window.open('https://sign.oodrive.com/calinda/sellandsign/#/login;href_back=https%253A%252F%252Fsign.oodrive.com%252Fcalinda%252Fsellandsign%252F%2523%252Fselectcontract', '_blank');
  }, []);

  return (
    <div className="h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="text-center max-w-md px-6">
        {/* Icône de signature */}
        <div className="mb-6 flex justify-center">
          <div className="bg-blue-600 p-4 rounded-full">
            <FileSignature className="w-12 h-12 text-white" />
          </div>
        </div>
        
        {/* Titre */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          SIGNATURE ÉLECTRONIQUE
        </h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-6">
          du mandat BDC
        </h2>
        
        {/* Animation de redirection */}
        <div className="mb-6">
          <div className="flex items-center justify-center space-x-2">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            <p className="text-gray-600">Redirection en cours...</p>
          </div>
        </div>

        {/* Message d'information */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex items-start space-x-3">
            <ExternalLink className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
            <p className="text-gray-700 text-left">
              Le formulaire de signature s'est ouvert dans un <strong>nouvel onglet</strong> de votre navigateur.
            </p>
          </div>
        </div>

        {/* Bouton si la redirection n'a pas fonctionné */}
        <div className="space-y-3">
          <p className="text-sm text-gray-500">
            Le formulaire ne s'est pas ouvert ?
          </p>
          <a
            href="https://yousign.app/workflows/forms/e38027cd-36c0-4989-b23a-c272a4111f02"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            <FileSignature className="w-5 h-5 mr-2" />
            Ouvrir le formulaire
          </a>
        </div>

        {/* Bouton retour */}
        <button
          onClick={() => window.location.href = '/dashboard'}
          className="mt-6 px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Retour au Dashboard
        </button>
      </div>
    </div>
  );
};

export default SignatureBDCPage;
